import { RefundExternalKeysFilter } from 'app/src/features/Shopping/Refund/components/functions'
import { FormItemEnum, type FormPropsType } from 'app/src/features/Shopping/shared'
import { ErrorMessage } from 'app/src/shared/components'
import { borderLessClassNames } from 'app/src/shared/helpers'
import { Calendar } from 'primereact/calendar'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import { useTranslation } from 'react-i18next'

export function RefundInvoiceForm(props: FormPropsType) {
  const { t } = useTranslation('shopping', { keyPrefix: 'Refund' })
  console.log('DATA', props.formData)
  console.log('REFUND', props.refund)
  return (
    <div className='mx-auto mt-6 max-w-6xl'>
      <div className='grid grid-cols-1 md:grid-cols-2'>
        <div className='col-span-1 my-[10px] grid grid-cols-1 md:mr-[20px]'>
          <label className='uppercase' htmlFor='documentId'>
            {t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.documentId')}
          </label>
          <InputText
            id='documentId'
            placeholder={t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.placeholder')}
            className={borderLessClassNames}
            pt={{ root: { className: 'font-bold w-full' } }}
            value={props.formData?.invoiceId}
            onChange={(event) => props.setFormData('invoiceId', event.currentTarget.value, FormItemEnum.STRING)}
            maxLength={100}
          ></InputText>
          <ErrorMessage errorMessage={props.formErrors?.invoiceId} />
        </div>
        <div className='col-span-1 my-[10px] grid grid-cols-1 md:mr-[20px]'>
          <label className='uppercase' htmlFor='invoiceDate'>
            {t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.documentDate')}
          </label>
          <Calendar
            id='invoiceDate'
            value={props.formData?.invoiceDate ? new Date(props.formData?.invoiceDate) : undefined}
            readOnlyInput={false}
            pt={{ root: { className: borderLessClassNames } }}
            placeholder={t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.dateFormatPlaceholder')}
            dateFormat={t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.dateFormat')}
            onSelect={(ev) => props.setFormData('invoiceDate', ev.value, FormItemEnum.DATE)}
            maxDate={new Date()}
            showIcon
          />
          <ErrorMessage errorMessage={props.formErrors?.invoiceDate} />
        </div>
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2'>
        <div className='col-span-1 my-[10px] grid grid-cols-1 md:mr-[20px]'>
          <label className='uppercase' htmlFor='vendorName'>
            {t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.vendorName')}
          </label>
          <InputText
            id='vendorName'
            placeholder={t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.placeholder')}
            className={borderLessClassNames}
            pt={{ root: { className: 'font-bold w-full' } }}
            value={props.formData?.vendorName}
            onChange={(event) => props.setFormData('vendorName', event.currentTarget.value, FormItemEnum.STRING)}
            maxLength={100}
          ></InputText>
          <ErrorMessage errorMessage={props.formErrors?.vendorName} />
        </div>
        <div className='col-span-1 my-[10px] grid grid-cols-1 md:mr-[20px]'>
          <label className='uppercase' htmlFor='vendorTaxId'>
            {t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.vendorTaxId')}
          </label>
          <InputText
            id='vendorTaxId'
            placeholder={t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.placeholder')}
            className={borderLessClassNames}
            pt={{ root: { className: 'font-bold w-full' } }}
            value={props.formData?.vendorTaxId}
            onChange={(event) => props.setFormData('vendorTaxId', event.currentTarget.value, FormItemEnum.STRING)}
            maxLength={100}
          ></InputText>
          <ErrorMessage errorMessage={props.formErrors?.vendorTaxId} />
        </div>
      </div>
      {props.refund?.rule?.externalKeys &&
        props.refund.rule.externalKeys.some((key) => RefundExternalKeysFilter(key, props.refund)) && (
          <div className='grid grid-cols-1 md:grid-cols-2'>
            {props.refund.rule.externalKeys
              .filter((key) => RefundExternalKeysFilter(key, props.refund))
              .map((x) => {
                const isNumber = x.format === 'number'
                return (
                  <div key={x.key} className='col-span-1 my-[10px] grid grid-cols-1 md:mr-[20px]'>
                    <label className='uppercase' htmlFor={x.key}>
                      {x.label}
                    </label>
                    {isNumber ? (
                      <div>
                        <IconField iconPosition='left'>
                          <InputIcon className='pi pi-euro'> </InputIcon>
                          <InputText
                            id={x.key ?? ''}
                            placeholder={t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.placeholder')}
                            className={borderLessClassNames}
                            pt={{ root: { className: 'font-bold w-full' } }}
                            value={props.formData?.[x.key ?? '']}
                            onChange={(event) => props.setFormData(x.key!, event.currentTarget.value, FormItemEnum.NUMBER)}
                          ></InputText>
                        </IconField>
                        <ErrorMessage errorMessage={props.formErrors?.[x.key ?? ''] ?? props.formErrors?.[x.key + 'Number']} />
                      </div>
                    ) : (
                      <div>
                        <InputText
                          id={x.key ?? ''}
                          placeholder={t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.placeholder')}
                          className={borderLessClassNames}
                          pt={{ root: { className: 'font-bold w-full' } }}
                          value={props.formData?.[x.key ?? '']}
                          onChange={(event) => props.setFormData(x.key!, event.currentTarget.value, FormItemEnum.STRING)}
                        ></InputText>
                        <ErrorMessage errorMessage={props.formErrors?.[x.key ?? '']} />
                      </div>
                    )}
                  </div>
                )
              })}
          </div>
        )}
      <div className='grid grid-cols-1 md:grid-cols-2'>
        <div className='col-span-1 my-[10px] grid grid-cols-1 md:mr-[20px]'>
          <label className='uppercase' htmlFor='invoiceTotal'>
            {t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.invoiceTotal')}
          </label>
          <IconField iconPosition='left'>
            <InputIcon className='pi pi-euro'> </InputIcon>

            <InputText
              id='invoiceTotal'
              placeholder={t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.placeholder')}
              className={borderLessClassNames}
              pt={{ root: { className: 'font-bold w-full' } }}
              value={props.formData?.invoiceTotal}
              maxLength={100}
              onChange={(event) => props.setFormData('invoiceTotal', event.currentTarget.value, FormItemEnum.NUMBER)}
            ></InputText>
          </IconField>
          <ErrorMessage errorMessage={props.formErrors?.invoiceTotal ?? props.formErrors?.invoiceTotalNumber} />
        </div>
        <div className='col-span-1 my-[10px] grid grid-cols-1 md:mr-[20px]'>
          <label className='uppercase' htmlFor='requestedRefundNumber'>
            {t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.requestedRefund')}
          </label>
          <IconField iconPosition='left'>
            <InputIcon className='pi pi-euro'> </InputIcon>
            <InputText
              id='requestedRefundNumber'
              placeholder={t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.placeholder')}
              className={borderLessClassNames}
              pt={{ root: { className: 'font-bold w-full' } }}
              value={props.formData?.requestedRefund}
              maxLength={100}
              onChange={(event) => props.setFormData('requestedRefund', event.currentTarget.value, FormItemEnum.NUMBER)}
            ></InputText>
          </IconField>
          <ErrorMessage
            errorMessage={
              props.formErrors?.requestedRefund ??
              props.formErrors?.requestedRefundNumber ??
              props.formErrors?.welfareCreditNumber ??
              props.formErrors?.['']
            }
          />
        </div>
      </div>
      {t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.formTrailer') && (
        <div dangerouslySetInnerHTML={{ __html: t('Funnel.Steps.InvoiceUpdate.FormFields.Labels.formTrailer') }} />
      )}
    </div>
  )
}
